module.exports = __webpack_public_path__ + "img/wx_qrcode.a508216e.png";